(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("underscore"));
	else if(typeof define === 'function' && define.amd)
		define(["underscore"], factory);
	else if(typeof exports === 'object')
		exports["Requester"] = factory(require("underscore"));
	else
		root["Requester"] = factory(root["underscore"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_3__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = {
	  Manager: __webpack_require__(1),
	  Request: __webpack_require__(2)
	};


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	var REQUIRED, Request, RequestManager, _, utils;

	Request = __webpack_require__(2);

	_ = __webpack_require__(3);

	utils = __webpack_require__(4);

	REQUIRED = ["baseRoute", "appKey"];

	RequestManager = function(endpoint_config, options) {
	  var Api, ApiWrapper, _config, _getDefaultRequestOptions, _handleGetOptions, _handleRequest, _log_requests, _paused, _pending, _running, _state, beforeSendWrapper, completeWrapper, errorWrapper, formatUrl, getOptions, successWrapper;
	  if (options == null) {
	    options = {};
	  }
	  _running = [];
	  _pending = [];
	  _paused = false;
	  _state = {
	    oid: void 0,
	    session: void 0,
	    impersonate_user_id: void 0
	  };
	  _config = _.extend({}, {
	    baseRoute: void 0,
	    debug: false,
	    debugWatchRequests: false,
	    appKey: void 0,
	    onGlobalError: void 0,
	    onGlobalSuccess: void 0,
	    onGlobalBeforeSend: void 0
	  }, options);
	  _.each(REQUIRED, function(key) {
	    if (!_config[key]) {
	      return console.error("Requester: " + key + " is required in config");
	    }
	  });
	  _log_requests = function(url, options) {
	    var prefix;
	    if (_config.debugWatchRequests) {
	      prefix = "Requester (" + (options.type || "") + "):";
	      if (options != null ? options.data : void 0) {
	        return console.debug(prefix, url, utils.jsonParse(options != null ? options.data : void 0));
	      } else {
	        return console.debug(prefix, url);
	      }
	    }
	  };
	  _getDefaultRequestOptions = function() {
	    var _defaultRequestOptions;
	    return _defaultRequestOptions = {
	      url: void 0,
	      urlExtend: void 0,
	      params: {
	        oid: _state.oid
	      },
	      headers: utils.compactObject({
	        "Content-Type": "application/json; charset=UTF-8",
	        "Accept": "application/json, text/plain",
	        "Application-Key": _config.appKey,
	        "Authorization": _state.session,
	        "Authorization-Provider": _state.session ? "evertrueauthtoken" : void 0,
	        "Authorization-Multifactor": 1,
	        "Authorization-Impersonate": _state.impersonate_user_id,
	        "Authorization-Auto-Send": 0
	      })
	    };
	  };
	  errorWrapper = function(original, options) {
	    var fn;
	    return fn = function(xhr, textStatus, error) {
	      if (_.isFunction(_config.onGlobalError)) {
	        return typeof _config.onGlobalError === "function" ? _config.onGlobalError(original, options, [xhr, textStatus, error]) : void 0;
	      } else if (_.isFunction(original)) {
	        return original(xhr, textStatus, error);
	      }
	    };
	  };
	  successWrapper = function(original, options) {
	    var fn;
	    return fn = function(resp, status, xhr) {
	      if (_.isFunction(_config.onGlobalSuccess)) {
	        return typeof _config.onGlobalSuccess === "function" ? _config.onGlobalSuccess(original, options, [resp, status, xhr]) : void 0;
	      } else if (_.isFunction(original)) {
	        return original(resp, status, xhr);
	      }
	    };
	  };
	  beforeSendWrapper = function(original, options) {
	    var fn;
	    return fn = function(xhr) {
	      xhr._options = options;
	      _running.push(xhr);
	      _pending = _.filter(_pending, function(pending_options) {
	        return pending_options._uid !== options._uid;
	      });
	      if (_.isFunction(_config.onGlobalBeforeSend)) {
	        return typeof _config.onGlobalBeforeSend === "function" ? _config.onGlobalBeforeSend(original, options, xhr) : void 0;
	      } else {
	        return typeof original === "function" ? original(xhr) : void 0;
	      }
	    };
	  };
	  completeWrapper = function(original, options) {
	    var fn;
	    return fn = function(xhr, status) {
	      _running = _.without(_running, xhr);
	      return typeof original === "function" ? original(xhr, status) : void 0;
	    };
	  };
	  formatUrl = function(url, opts) {
	    var url_root;
	    url_root = url;
	    if (opts.urlExtend) {
	      url_root += opts.urlExtend;
	    }
	    url = _config.baseRoute + url_root;
	    if (!_.isEmpty(opts.params)) {
	      url += "?" + decodeURIComponent(utils.paramify(opts.params));
	    }
	    return url;
	  };
	  getOptions = function(url, opts) {
	    var ajax_options;
	    if (opts == null) {
	      opts = {};
	    }
	    options = utils.deepObjectExtend(_getDefaultRequestOptions(), utils.compactObject(opts));
	    options = utils.compactObject(options);
	    options.params = utils.compactObject(options.params);
	    options.headers = utils.compactObject(options.headers);
	    options._uid = Math.random().toString(36).slice(2);
	    options._url_prefix = url;
	    options._original_options = opts;
	    if (!options.url) {
	      options.url = formatUrl(url, _.clone(options));
	    }
	    ajax_options = _.clone(options);
	    ajax_options.error = errorWrapper(opts.error, options);
	    ajax_options.success = successWrapper(opts.success, options);
	    ajax_options.complete = completeWrapper(opts.complete, options);
	    ajax_options.beforeSend = beforeSendWrapper(opts.beforeSend, options);
	    return _.clone(ajax_options);
	  };
	  _handleGetOptions = function(url, request_options) {
	    options = getOptions(url, request_options);
	    if (!request_options.forceRequest) {
	      _pending.push(options);
	    }
	    if (!_paused || request_options.forceRequest) {
	      _log_requests(url, options);
	      return options;
	    }
	  };
	  _handleRequest = function(url, options) {
	    var req_opts;
	    if (req_opts = _handleGetOptions(url, options)) {
	      return typeof _config.onRequest === "function" ? _config.onRequest(req_opts) : void 0;
	    }
	  };
	  Api = function() {
	    _.each(endpoint_config, (function(_this) {
	      return function(group, group_key) {
	        return _.each(group, function(endpoint, key) {
	          if (_this[group_key] == null) {
	            _this[group_key] = {};
	          }
	          return _this[group_key][key] = Request(endpoint, _handleGetOptions, _config.onRequest);
	        });
	      };
	    })(this));
	    return this;
	  };
	  Api.prototype = {
	    config: function(object) {
	      return _.extend(_config, object);
	    },
	    set: function(object, silent) {
	      if (_.isEmpty(_.difference(_.keys(object), _.keys(_state)))) {
	        return _.extend(_state, utils.deepClone(object));
	      } else {
	        return console.warn("Requester: _.keys(state) are the only accepted state values");
	      }
	    },
	    cancel: function() {
	      _.each(_running, function(req) {
	        return typeof req.abort === "function" ? req.abort() : void 0;
	      });
	      return _running = [];
	    },
	    pause: function() {
	      _paused = true;
	      _pending = _.compact(_.flatten([_.pluck(_running, "_options"), _pending]));
	      return this.cancel();
	    },
	    isPaused: function() {
	      return _paused;
	    },
	    enqueue: function(options) {
	      if (options == null) {
	        options = {};
	      }
	      if (_paused) {
	        return _pending.push(options);
	      } else {
	        return _handleRequest(options._url_prefix, options._original_options);
	      }
	    },
	    clearQueue: function() {
	      return _pending = [];
	    },
	    restart: function() {
	      _paused = false;
	      _.each(_pending, function(req) {
	        return _handleRequest(req._url_prefix, req._original_options);
	      });
	      return _pending = [];
	    },
	    runRequest: function(url_prefix, original_options) {
	      return _handleRequest(url_prefix, original_options);
	    },
	    findEndpoint: function(search_endpoint) {
	      var api_wrapper;
	      api_wrapper = void 0;
	      _.each(endpoint_config, (function(_this) {
	        return function(group, group_key) {
	          return _.each(group, function(endpoint, key) {
	            if (endpoint === search_endpoint) {
	              return api_wrapper = _this[group_key][key];
	            }
	          });
	        };
	      })(this));
	      if (api_wrapper) {
	        return api_wrapper;
	      } else {
	        return Request(search_endpoint, _handleGetOptions, _config.onRequest);
	      }
	    }
	  };
	  ApiWrapper = new Api();
	  if (_config.debug) {
	    window._api_requests = _.extend(ApiWrapper, {
	      _getRunning: function() {
	        return _running;
	      },
	      _getPending: function() {
	        return _pending;
	      },
	      _getDefaultRequestOptions: function() {
	        return _getDefaultRequestOptions();
	      },
	      _getState: function() {
	        return _state;
	      },
	      _getConfig: function() {
	        return _config;
	      },
	      _watch: function() {
	        return _config.debugWatchRequests = !_config.debugWatchRequests;
	      }
	    });
	  }
	  return ApiWrapper;
	};

	module.exports = RequestManager;


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	var Request, _;

	_ = __webpack_require__(3);

	Request = function(url, getOptions, onRequest) {
	  var _parseUrl, api;
	  if (!url) {
	    console.error("Api.request requires url");
	  }
	  _parseUrl = function(map) {
	    var path, ref;
	    path = url || "";
	    if (path.match(":")) {
	      if ((ref = _.keys(map)) != null ? ref.length : void 0) {
	        return path.replace(/\/:[^\/]*/g, function(match) {
	          var key;
	          key = match.replace(":", "").replace("/", "");
	          if (map[key]) {
	            return "/" + map[key];
	          } else {
	            return "";
	          }
	        });
	      } else {
	        return console.error("Endpoint " + url + " requires arguments, set 'urlArgs' object in options");
	      }
	    } else {
	      return path;
	    }
	  };
	  return api = {
	    send: function(options) {
	      if (options == null) {
	        options = {};
	      }
	      return typeof onRequest === "function" ? onRequest(options) : void 0;
	    },
	    request: function(options) {
	      var parsed_url, req_opts;
	      if (options == null) {
	        options = {};
	      }
	      parsed_url = _parseUrl(options.urlArgs);
	      if (req_opts = getOptions(parsed_url, options)) {
	        return this.send(req_opts);
	      }
	    },
	    get: function(options) {
	      if (options == null) {
	        options = {};
	      }
	      return this.request(_.extend({}, options, {
	        type: "GET"
	      }));
	    },
	    put: function(options) {
	      if (options == null) {
	        options = {};
	      }
	      return this.request(_.extend({}, options, {
	        type: "PUT"
	      }));
	    },
	    post: function(options) {
	      if (options == null) {
	        options = {};
	      }
	      return this.request(_.extend({}, options, {
	        type: "POST"
	      }));
	    },
	    "delete": function(options) {
	      if (options == null) {
	        options = {};
	      }
	      return this.request(_.extend({}, options, {
	        type: "DELETE"
	      }));
	    },
	    patch: function(options) {
	      if (options == null) {
	        options = {};
	      }
	      return this.request(_.extend({}, options, {
	        type: "PATCH"
	      }));
	    }
	  };
	};

	module.exports = Request;


/***/ }),
/* 3 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	var _, jqueryParam;

	_ = __webpack_require__(3);

	jqueryParam = __webpack_require__(5);

	module.exports = {
	  jsonParse: function(data) {
	    var e;
	    try {
	      return JSON.parse(data);
	    } catch (error) {
	      e = error;
	    }
	  },
	  compactObject: function(object) {
	    var obj;
	    obj = {};
	    _.each(object, function(value, key) {
	      if (!(_.isUndefined(value) || _.isNull(value))) {
	        return obj[key] = value;
	      }
	    });
	    return obj;
	  },
	  deepClone: function(item) {
	    if (!_.isObject(item) || _.isFunction(item)) {
	      return item;
	    } else if (_.isArray(item)) {
	      return _.map(item, _.cloneData);
	    } else if (_.isObject(item)) {
	      return _.mapObject(item, _.cloneData);
	    } else {
	      return item;
	    }
	  },
	  deepObjectExtend: function(target, source) {
	    _.each(source, (function(_this) {
	      return function(val, prop) {
	        if (_.has(target, prop) && typeof source[prop] === "object" && source[prop] !== null) {
	          return target[prop] = _this.deepObjectExtend(target[prop], source[prop]);
	        } else {
	          return target[prop] = source[prop];
	        }
	      };
	    })(this));
	    return target;
	  },
	  paramify: function(params) {
	    return jqueryParam(params);
	  }
	};


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * @preserve jquery-param (c) 2015 KNOWLEDGECODE | MIT
	 */
	(function (global) {
	    'use strict';

	    var param = function (a) {
	        var s = [], rbracket = /\[\]$/,
	            isArray = function (obj) {
	                return Object.prototype.toString.call(obj) === '[object Array]';
	            }, add = function (k, v) {
	                v = typeof v === 'function' ? v() : v === null ? '' : v === undefined ? '' : v;
	                s[s.length] = encodeURIComponent(k) + '=' + encodeURIComponent(v);
	            }, buildParams = function (prefix, obj) {
	                var i, len, key;

	                if (prefix) {
	                    if (isArray(obj)) {
	                        for (i = 0, len = obj.length; i < len; i++) {
	                            if (rbracket.test(prefix)) {
	                                add(prefix, obj[i]);
	                            } else {
	                                buildParams(prefix + '[' + (typeof obj[i] === 'object' ? i : '') + ']', obj[i]);
	                            }
	                        }
	                    } else if (obj && String(obj) === '[object Object]') {
	                        for (key in obj) {
	                            buildParams(prefix + '[' + key + ']', obj[key]);
	                        }
	                    } else {
	                        add(prefix, obj);
	                    }
	                } else if (isArray(obj)) {
	                    for (i = 0, len = obj.length; i < len; i++) {
	                        add(obj[i].name, obj[i].value);
	                    }
	                } else {
	                    for (key in obj) {
	                        buildParams(key, obj[key]);
	                    }
	                }
	                return s;
	            };

	        return buildParams('', a).join('&').replace(/%20/g, '+');
	    };

	    if (typeof module === 'object' && typeof module.exports === 'object') {
	        module.exports = param;
	    } else if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	            return param;
	        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else {
	        global.param = param;
	    }

	}(this));



/***/ })
/******/ ])
});
;